<template>
    <div>
        <div>
            <div class="flex flex-row" v-if="selectedImage">
                <Button class="mr-2 p-button p-button-warning" type="button" icon="pi pi-image" label="Preview Selected Image" @click="toggleImagesPreview" />
                <Button label="Remove Selected Image" @click="confirmRemove" />
            </div>
            <Button v-else label="Select Existing Images" @click="toggleImagesPanel" />

            <OverlayPanel ref="op1">
                <img :src="selectedImage?.vignette" alt="Selected Image Preview" />
            </OverlayPanel>
        </div>
        <OverlayPanel ref="op" :showCloseIcon="true" id="overlay_panel" style="width: 450px" :breakpoints="{ '960px': '75vw' }">
            <div v-if="getGalleryImages?.length <= 0">No attachments available</div>
            <Galleria :value="getGalleryImages" :numVisible="2" :circular="true" containerStyle="max-width: 400px; margin: auto">
                <template #item="slotProps">
                    <img :src="slotProps.item.vignette" alt="Image Thumbnail" style="width: 100%; display: block" @dblclick="imageClicked(slotProps.item)" />
                </template>
                <template #thumbnail="slotProps">
                    <img :src="slotProps.item.thumbnail" alt="Image Thumbnail" style="width: 100%; display: block" @dblclick="imageClicked(slotProps.item)" />
                </template>
                <template #caption="slotProps">
                    <div class="text-xl mb-2 font-bold">{{ slotProps.item.title }}</div>
                </template>
            </Galleria>
        </OverlayPanel>
        <ConfirmPopup></ConfirmPopup>
    </div>
</template>

<script>
import { ref, computed, onMounted } from 'vue';
import { useConfirm } from 'primevue/useconfirm';
import { useToast } from 'primevue/usetoast';
import useFileComposable from '../../composables/FileComposable';
export default {
    setup(props, { emit }) {
        const confirm = useConfirm();
        const toast = useToast();
        const { images, fetchImages } = useFileComposable();
        const op = ref();
        const op1 = ref();
        const selectedImage = ref();

        onMounted(async () => {
            // params true refers to user id specific images
            await fetchImages(true);
        });

        const toggleImagesPanel = (event) => {
            op.value.toggle(event);
        };

        const toggleImagesPreview = (event) => {
            op1.value.toggle(event);
        };

        const getGalleryImages = computed(() => {
            {
                return images.value?.map((item) => ({
                    id: item?.id,
                    // Use local_uri or s3_uri depending on your use case
                    thumbnail: item?.thumbnail,
                    src: item?.local_uri,
                    title: item?.original_name,
                    vignette: item?.vignette,
                }));
            }
        });

        const imageClicked = (image, event) => {
            selectedImage.value = image;
            emit('image-selected', image.id);
            op.value.toggle(event);
        };

        const confirmRemove = () => {
            confirm.require({
                header: 'Confirmation',
                message: 'Are you sure you want to the selected image?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    selectedImage.value = null;
                    emit('image-selected', null);
                    toast.add({ severity: 'info', summary: 'Confirmed', detail: 'Image Removed', life: 3000 });
                },
                reject: () => {
                    toast.add({ severity: 'error', summary: 'Rejected', detail: 'Cancelled', life: 5000 });
                },
            });
        };

        return {
            op,
            op1,
            selectedImage,
            toggleImagesPanel,
            toggleImagesPreview,
            getGalleryImages,
            imageClicked,
            confirmRemove,
        };
    },
};
</script>
